/**
 * Authenticated app home. Public `/` shows the marketing landing when logged out.
 */
export const APP_HOME_PATH = "/dashboard";
